import { Trash2 } from 'lucide-react';

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

import type { FlatField } from '../types'; // adjust if your FlatField type lives elsewhere
import { EmptyInspector } from './EmptyInspector';
import { FieldMeta } from './FieldMeta';
import { ArrayOfObjectsEditor } from './ArrayOfObjectsEditor';
import { LeafValueEditor } from './LeafValueEditor';
import type { JsonRecord } from '@/domain/entities/property-schema';

export function TemplateInspectorCard(props: {
  selectedField: FlatField | null;
  selectedValue: unknown;
  tplData: JsonRecord;
  onSetValueForSelected: (value: unknown) => void;
  onSetValueForPath: (path: string, value: unknown) => void;
  onExcludeSelected: () => void;
  onClearSelected: () => void;
  readOnly?: boolean;
}) {
  const {
    selectedField,
    selectedValue,
    tplData,
    onSetValueForSelected,
    onSetValueForPath,
    onExcludeSelected,
    onClearSelected,
    readOnly = false,
  } = props;

  return (
    <Card className="rounded-2xl">
      <CardHeader>
        <CardTitle>Field Inspector</CardTitle>
        <CardDescription>Select a field on the left to set its seed value.</CardDescription>
      </CardHeader>

      <CardContent className="space-y-4">
        {!selectedField ? (
          <EmptyInspector />
        ) : (
          <div className="space-y-4">
            <FieldMeta field={selectedField} />

            {selectedField.node.type === 'array' ? (
              <ArrayOfObjectsEditor
                field={selectedField}
                tplData={tplData}
                setValueForPath={onSetValueForPath}
                readOnly={readOnly}
              />
            ) : (
              <LeafValueEditor field={selectedField} value={selectedValue} onChange={onSetValueForSelected} />
            )}

            <div className="flex items-center justify-end gap-2">
              <Button type="button" variant="outline" onClick={onExcludeSelected} disabled={readOnly}>
                <Trash2 className="mr-2 h-4 w-4" />
                Exclude field
              </Button>

              <Button type="button" variant="outline" onClick={onClearSelected} disabled={readOnly}>
                Clear value
              </Button>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
